import { render, staticRenderFns } from "./QuestionCardForSpeed.vue?vue&type=template&id=74412793&"
import script from "./QuestionCardForSpeed.vue?vue&type=script&lang=ts&"
export * from "./QuestionCardForSpeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports